import { IStore } from "..";

export const getLanguage = (state: IStore): string => state.languageReducer.language;
